import hash from "object-hash";

const getHashValue = (obj) => hash(obj);

export default getHashValue;
